import { NgModule } from '@angular/core';

import { EffectsModule, provideEffects } from '@ngrx/effects';
import { provideState, StoreModule } from '@ngrx/store';

import { provide } from '@core/common-legacy';

import { RecruiteeRegionsHttpClient } from './recruitee-regions-http-client.service';
import { RegionEffects } from './regions.effects';
import { RegionNamespace, RegionReducer } from './regions.store';
import { RegionsHttpClient } from './regions.types';
import { TellentRegionsHttpClient } from './tellent-regions-http-client.service';

@NgModule({
  imports: [
    StoreModule.forFeature(RegionNamespace, RegionReducer),
    EffectsModule.forFeature([RegionEffects]),
  ],
})
export class RegionsDataModule {}

export const provideRecruiteeRegionsClient = provide(RegionsHttpClient, {
  useClass: RecruiteeRegionsHttpClient,
});

export const tellentRegionsData = [
  provideEffects([RegionEffects]),
  provideState(RegionNamespace, RegionReducer),
  provide(RegionsHttpClient, {
    useClass: TellentRegionsHttpClient,
  }),
];
